import React, { ReactChild, useEffect } from 'react'
import {
  NotificationTypes,
  useNotification,
} from '../../provider/NotificationProvider'
import { useTheme } from '../../provider/ThemeProvider'
import { P } from '../../styles/Elements'
import StandardVerticalSpace from '../../styles/StandardVerticalSpace'
import ConfirmationIcon from '../icons/Confirmation'
import FailedIcon from '../icons/Failed'
import QueryIcon from '../icons/Query';
import { IconWrapper, Wrapper, StyledNotificationText } from './styles'

export const NotificationText: React.FC = ({ children }) => {
  return (
    <StyledNotificationText>
      <P>{children}</P>
    </StyledNotificationText>
  )
}

interface NotificationProps {
  scrollToTop: () => void
}

const Notification: React.FC<NotificationProps> = ({ scrollToTop }) => {
  const { theme } = useTheme()
  const { notification } = useNotification()

  useEffect(() => {
    if (notification.message) {
      scrollToTop()
    }
  }, [notification.message])

  if (!notification.message) {
    return null
  }

  const iconDict: Record<NotificationTypes, ReactChild> = {
    WARNING: <QueryIcon />,
    ERROR: <FailedIcon />,
    SUCCESS: <ConfirmationIcon />,
  }

  return (
    <Wrapper dolaTheme={theme}>
      <IconWrapper>{iconDict[notification.type]}</IconWrapper>
      <StandardVerticalSpace />
      {notification.message}
    </Wrapper>
  )
}

export default Notification
